import LinkifyIt from 'linkify-it';
import tlds from 'tlds';

const linkify = LinkifyIt().tlds(tlds);

/**
 * Splits text into plain strings and linkify-it matches, preserving
 * surrounding text so job/activity comments can render safe anchors.
 */
export function splitLinkifyText(str: string): Array<string | LinkifyIt.Match> {
  const matches = linkify.match(str);

  if (matches) {
    const parts: Array<string | LinkifyIt.Match> = [];
    let last = 0;

    matches.forEach((match) => {
      if (last < match.index) {
        parts.push(str.substring(last, match.index));
      }

      parts.push(match);

      last = match.lastIndex;
    });

    if (last < str.length) {
      parts.push(str.substring(last));
    }

    return parts;
  }

  return [str];
}
